import React from "react";

import cx from "classnames";

import styles from "./css/NoteCard.module.css";
import headerStyles from "./NoteHeader/NoteHeader.module.css";

export function loadingBar(width: number, className?: string) {
	return (
		<div className={cx(styles.loadingBar, className)} style={{ width: `${width}%` }}>
			&nbsp;
		</div>
	);
}

export function LoadingNoteCard({ delay = false }) {
	return (
		<div className={cx(styles.noteCard, { [styles.loadingNote]: delay })}>
			<div className="main">
				<article className={cx(styles.noteContent, styles.shimmer)}>
					<header className={headerStyles.header}>
						<div className={headerStyles.leftSide}>
							<h2 className={cx(headerStyles.noteTitle, styles.loadingBar)} style={{ width: "160px" }}>
								&nbsp;
							</h2>
						</div>
						<div className={headerStyles.rightSide}>&nbsp;</div>
					</header>
					<div className={styles.editor}>
						<div className="ProseMirror">
							{loadingBar(40, styles.loadingHeader)}
							{loadingBar(30)}
							{loadingBar(70)}
							{loadingBar(40)}
							{loadingBar(50, styles.loadingHeader)}
							{loadingBar(60)}
							{loadingBar(30)}
							{loadingBar(40)}
							{loadingBar(20, styles.loadingHeader)}
							{loadingBar(50)}
						</div>
					</div>
				</article>
			</div>
		</div>
	);
}
